import React from 'react'
// import CustomLink from '@shared/components/customLink'
import styles from '../style.module.scss'
import PropTypes from 'prop-types'
import { formatDate } from '@shared-submodule/utils'

export default function StandingForm({ match }) {
  return (
    <tr>
      <td className="w-50">
        <span className="d-none d-sm-block ">{match?.oOpponent?.sTitle}</span>
        <span className="d-block d-sm-none">{match?.oOpponent?.sAbbr}</span>
        {/* <CustomLink className={`d-inline-block text-decoration-underline ${isDailyHuntMode ? 'pe-none' : ''}`} href={`/${match?.oSeo?.sSlug}`}>
            {match?.sWinMargin && !data.isDraw ? `${data.isWinner ? 'Won' : 'Loss'} by ${match?.sWinMargin}` : match?.sStatusNote}
          </CustomLink> */}
      </td>
      <td className='d-none d-md-table-cell'>{match?.sDescription}</td>
      <td>
        <span className="d-none d-md-block">{formatDate(match.dStartDate, 'DD MMM YYYY')}</span>
        <span className="d-md-none">{formatDate(match.dStartDate, 'DD MMM')}</span>
      </td>
      {match?.sResult ? (
        <td className={match?.iWinnerId === match?.oOpponent?.iTeamId ? styles.loss : styles.win}>{match?.sResult}</td>
      ) : (
        <td>-</td>
      )}
    </tr>
  )
}

StandingForm.propTypes = {
  match: PropTypes.object.isRequired,
  teamId: PropTypes.string,
  isDailyHuntMode: PropTypes.bool
}
